// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { State, LoadingOrganizationsAction, selectOrganizations } from '@app/access-management/state';
import { Observable } from 'rxjs';
import { Loadable, needsLoading, Loaded, MaybeLoadable, GoAction, ScopeCategory } from '@app/core';
import { take, filter, map } from 'rxjs/operators';
import { SelectOrganizationAction } from './organization-details/organization-details.actions';

const shouldLoadOrganizations = (organizations: MaybeLoadable) => needsLoading<Loaded<ScopeCategory[]>>(organizations);
const hasOrganizationsState = (organizations: MaybeLoadable) => !needsLoading<Loaded<ScopeCategory[]>>(organizations);

@Injectable({ providedIn: 'root' })
export class OrganizationsFacadeService {
  loadableOrganizations$: Observable<Loaded<ScopeCategory[]> | Loadable> = this.store.pipe(select(selectOrganizations));
  organizations$: Observable<ScopeCategory[]> = this.loadableOrganizations$.pipe(
    filter<Loaded<ScopeCategory[]> | Loadable>(hasOrganizationsState),
    map(organizationList => organizationList.data)
  );

  constructor(private store: Store<State>) {}

  initialize() {
    this.loadableOrganizations$
      .pipe(
        take(1),
        filter(shouldLoadOrganizations)
      )
      .subscribe(() => this.store.dispatch(new LoadingOrganizationsAction()));
  }

  selectOrganization(organization: ScopeCategory) {
    this.store.dispatch(new SelectOrganizationAction(organization));
    this.store.dispatch(new GoAction(['/iam/organizations', organization.id]));
  }
}



// WEBPACK FOOTER //
// ./src/app/access-management/state/organizations.facade.ts